// extracted by mini-css-extract-plugin
module.exports = {"listing-item-container":"category-listing-item-component_listing-item-container__2atZe","title":"category-listing-item-component_title__rbqNa"};